import { HTTP } from '@/api/http-common'
import { HTTPMultipartFormData } from '@/api/http-multipart-form'

export default {
  getCustomForm (callback, param) {
    HTTP.get(param.token + '/orders/form').then(response => {
      if (response.data.data.form.status === '1') {
        response.data.data.detail.forEach(item => {
          item.value = ''
          if (item.type === 'dropdown') {
            item.value = 'form-default-value'
          } else if (item.type === 'checkbox') {
            item.value = []
          }
        })
      }
      callback(response.data)
    }).catch(e => {
      console.log(e)
    })
  },
  uploadFile (callback, param) {
    HTTPMultipartFormData.post(param.token + '/orders/files', param.formData).then(response => {
      callback(response.data)
    }).catch(e => {
      console.log(e)
      if (e.response.status === 400 || e.response.status === 500) {
        callback(e.response)
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/custom_form/index.js